<template>
  <!-- Inovices card -->
  <div class="position-relative">
    <div
      v-if="summary"
      class="row d-flex flex-nowrap overflow-auto disable_line"
    >
      <div class="col-xl-2 col-lg-4 col-6 d-flex">
        <div class="card inovices-card w-100">
          <div
            class="card-body d-flex flex-column justify-content-between h-100"
          >
            <div class="dash-widget-header">
              <span class="inovices-widget-icon bg-info-light">
                <img src="@/assets/img/icons/receipt-item.svg" alt="" />
              </span>
              <div class="dash-count">
                <div class="dash-title">Total Invoice</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="dash-widget-header">
                <div class="dash-count">
                  <div class="dash-counts">
                    <p>
                      {{
                        summary?.all?.amount
                          ? useCurrency(summary?.all?.amount)
                          : useCurrency(0)
                      }}
                    </p>
                  </div>
                  <p class="inovices-all">
                    No of Invoice
                    <span>{{ summary?.all?.count }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-lg-4 col-6 d-flex">
        <div class="card inovices-card w-100">
          <div class="card-body">
            <div class="dash-widget-header">
              <span class="inovices-widget-icon bg-warning-light">
                <img src="@/assets/img/icons/archive-book.svg" alt="" />
              </span>
              <div class="dash-count">
                <div class="dash-title">Total Draft</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="dash-widget-header">
                <div class="dash-count">
                  <div class="dash-counts">
                    <p>
                      {{
                        summary?.draft?.amount
                          ? useCurrency(summary?.draft?.amount)
                          : useCurrency(0)
                      }}
                    </p>
                  </div>
                  <p class="inovices-all">
                    No of Invoice
                    <span
                      class="rounded-circle bg-light-gray"
                      >{{ summary?.draft?.count }}</span
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-lg-4 col-6 d-flex">
        <div class="card inovices-card w-100">
          <div
            class="card-body d-flex flex-column justify-content-between h-100"
          >
            <div class="dash-widget-header">
              <span class="inovices-widget-icon bg-green-light">
                <img src="@/assets/img/icons/message-edit.svg" alt="" />
              </span>
              <div class="dash-count">
                <div class="dash-title">Total Paid</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="dash-widget-header">
                <div class="dash-count">
                  <div class="dash-counts">
                    <p>
                      {{
                        summary?.paid?.amount
                          ? useCurrency(summary?.paid?.amount)
                          : useCurrency(0)
                      }}
                    </p>
                  </div>
                  <p class="inovices-all">
                    No of Invoice
                    <span>{{ summary?.paid?.count }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-lg-4 col-6 d-flex">
        <div class="card inovices-card w-100">
          <div
            class="card-body d-flex flex-column justify-content-between h-100"
          >
            <div class="dash-widget-header">
              <span class="inovices-widget-icon bg-primary-light">
                <img src="@/assets/img/icons/transaction-minus.svg" alt="" />
              </span>
              <div class="dash-count">
                <div class="dash-title">Total Pending</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="dash-widget-header">
                <div class="dash-count">
                  <div class="dash-counts">
                    <p>
                      {{
                        summary?.pending?.amount
                          ? useCurrency(summary?.pending?.amount)
                          : useCurrency(0)
                      }}
                    </p>
                  </div>
                  <p class="inovices-all">
                    No of Invoice
                    <span>{{ summary?.pending?.count }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-2 col-lg-4 col-6 d-flex">
        <div class="card inovices-card w-100">
          <div
            class="card-body d-flex flex-column justify-content-between h-100"
          >
            <div class="dash-widget-header">
              <span class="inovices-widget-icon bg-danger-light">
                <img src="@/assets/img/icons/3d-rotate.svg" alt="" />
              </span>
              <div class="dash-count">
                <div class="dash-title">Total Refunded</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="dash-widget-header">
                <div class="dash-count">
                  <div class="dash-counts">
                    <p>
                      {{
                        summary?.refunded?.amount
                          ? useCurrency(summary?.refunded?.amount)
                          : useCurrency(0)
                      }}
                    </p>
                  </div>
                  <p class="inovices-all">
                    No of Invoice
                    <span>{{ summary?.refunded?.count }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-lg-4 col-6 d-flex">
        <div class="card inovices-card w-100">
          <div class="card-body">
            <div class="dash-widget-header">
              <span class="inovices-widget-icon bg-danger-light">
                <img src="@/assets/img/icons/archive-book.svg" alt="" />
              </span>
              <div class="dash-count">
                <div class="dash-title">Total Overdue</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="dash-widget-header">
                <div class="dash-count">
                  <div class="dash-counts">
                    <p>
                      {{
                        summary?.overdue?.amount
                          ? useCurrency(summary?.overdue?.amount)
                          : useCurrency(0)
                      }}
                    </p>
                  </div>
                  <p class="inovices-all">
                    No of Invoice
                    <span
                      class="rounded-circle bg-light-gray"
                      >{{ summary?.overdue?.count }}</span
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Inovices card -->
</template>

<script setup>
import { useCurrency } from "@/assets/composables/currency";
import { onMounted, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const summary = computed(() => {
  return store.getters["invoices/summary"];
});

const getInvoicesSummary = () => {
  store.dispatch("invoices/getInvoicesSummary");
};

onMounted(() => {
  getInvoicesSummary();
});
</script>

<style>
.disable_line::-webkit-scrollbar {
  display: none;
}
</style>
